<template>
  <div class="results">
    <section class="headtop">
      <div class="container">
        <div class="col-sm-9 right-border">
          <h1>Results</h1>
          <br>
          <RunButtons :key="'runbuttons_' + currentStep" />
        </div>
        <div class="col-sm-3">
          <CovidStatus :key="'covidstatus_' + currentStep" />
        </div>
        <div class="clearfix" />
      </div>
    </section>

    <div class="row headtext">
      <div class="container">
        <div class="col-md-9 column">
          <SavedRuns @load-run-to-compare="loadRunToCompare" />
        </div>
      </div>
    </div>

    <div class="container">
      <div class="clearfix">
        <div class="col-xs-10">
          <ul class="nav nav-pills">
            <template v-for="(zone, index) in zoneCategories">
              <li
                :key="index"
                role="presentation"
                :class="chosenOutputZone == index ? 'active' : ''"
              >
                <a @click="displayCurrentValues(index)">{{ zone.label }}</a>
              </li>
            </template>
          </ul>
        </div>
        <div class="col-xs-2 text-right help-button-container">
          <a
            href
            class="help-button"
            @click.prevent="displayModal('help')"
          >
            <small>
              <span class="badge badge-info">?</span>
              <strong>Help</strong>
            </small>
          </a>
        </div>
      </div>
      <br>
      <h3>Impact on key factors</h3>
      <br>

      <div class="row">
        <template v-for="output in kpiBoxOutputs">
          <div
            :key="currentStep + '_' + output.name"
            class="col-xs-4"
          >
            <section class="widget kpi-container">
              <h4>
                {{ output.label }}
                <span
                  class="info-badge badge hidden"
                  data-toggle="popover"
                  data-trigger="hover"
                  data-container="body"
                  data-placement="right"
                  :data-title="output.label"
                  :data-content="output.description"
                >i</span>
              </h4>
              <p class="kpi-value">
                {{ output.formattedValue }}
              </p>
              <p class="kpi-baseline">
                <!-- <span
                  :class="
                    'udm-badge badge badge-' +
                      output.formattedBaselineColor +
                      ' badge-' +
                      output.formattedBaselineArrowClass
                  "
                >i</span> -->
                {{ output.formattedBaselineValue }}
              </p>
              <div class="kpi-footer">
                <a
                  class="btn btn-xs"
                  @click="viewKPIDetails(output)"
                >
                  <img
                    src="/static/img/udm/icon-graph.png"
                    class="charts-icon"
                  >
                  View graph
                </a>
              </div>
            </section>
            <template v-if="output.name === 'BU vacancy rate by zone category'">
              <br><br>
            </template>
          </div>
        </template>
      </div>
    </div>
    <KPIDetailsModalComponent
      :key="currentStep + ',' + chosenOutputZone + ',' + graphBaselineName"
      :output="detailsOutput"
      :chosen-output-zone="chosenOutputZone"
      :baseline-output="graphBaseline"
      :baseline-name="graphBaselineName"
      :saved-run-name="currentRun.getName()"
    />
    <HelpModalComponent />
  </div>
</template>

<script>
import HelpModalComponent from "../components/modals/Help";
import KPIDetailsModalComponent from "../components/modals/KPIDetails";
import CovidStatus from "../components/CovidStatus";
import SavedRuns from "../components/SavedRuns";
import RunButtons from "../components/RunButtons";

import data from "../services/data";
import baselines from "../storage/data/baselines";
import numeral from "numeral";
import Run from "../storage/Run";

export default {
  components: {
    KPIDetailsModalComponent,
    CovidStatus,
    HelpModalComponent,
    RunButtons,
    SavedRuns
  },
  data() {
    return {
      currentRun: this.$root.$data.sharedStorage.getCurrentRun(),
      currentStep: 0,
      savedRuns: this.$root.$data.sharedStorage.getSavedRuns(),
      zoneCategories: data.zoneCategories,
      runStages: data.runStages,
      debug: "",
      kpiBoxOutputs: [],
      detailsOutput: {},
      chosenOutputZone: 0,
      mapPopupData: {},
      graphBaseline: null,
      graphBaselineName: ""
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.$root.$data.eventHub.$on("new-data-arrived", () => {
      this.currentRun = this.$root.$data.sharedStorage.getCurrentRun();
      this.currentStep = this.currentRun.getCurrentStep();
      this.calculateKpiBoxOutputs();
      this.displayCurrentValues();
    });

    const slug = this.currentRun.getComparisionSlug();
    if (slug) {
      this.loadRunToCompare(slug);
    } else {
      const scenario = this.currentRun.getScenario();
      let index;
      for (let i = 0; i < data.scenarios.length; i++) {
        if (scenario.name === data.scenarios[i].name) {
          index = i;
        }
      }
      this.loadRunToCompare(`scenario_${index}`);
    }
  },
  mounted() {
    this.calculateKpiBoxOutputs();
    this.displayCurrentValues();
    this.calculateMapPopupValues();
    this.currentRun = this.$root.$data.sharedStorage.getCurrentRun();
    this.currentStep = this.currentRun.getCurrentStep();
  },
  methods: {
    calculateMapPopupValues() {
      this.currentRun = this.$root.$data.sharedStorage.getCurrentRun();
      var savedOutput = this.currentRun.getSavedOutput();
      if (!savedOutput) {
        return;
      }

      var zoneValues = {};
      var title = "";

      for (var zone of data.zones) {
        var population =
          savedOutput &&
          savedOutput["Population by zone category"] &&
          savedOutput["Population by zone category"][zone.name]
            ? savedOutput["Population by zone category"][zone.name]
            : [];
        if (population && population.length > 0) {
          population = population[population.length - 1];
        }
        population = numeral(population).format("0.0A");

        var jobs =
          savedOutput &&
          savedOutput["Jobs filled by zone category"] &&
          savedOutput["Jobs filled by zone category"][zone.name]
            ? savedOutput["Jobs filled by zone category"][zone.name]
            : [];
        if (jobs && jobs.length > 0) {
          jobs = jobs[jobs.length - 1];
        }
        jobs = numeral(jobs).format("0.0A");

        var value = "";
        value += `Population: ${population}<br>`;
        value += `Jobs: ${jobs}`;

        zoneValues[zone.name] = {
          label: zone.label,
          value: value
        };
      }

      this.mapPopupData = {
        title: title,
        zones: zoneValues
      };
    },
    setBaseline(newBaselineData) {
      this.currentRun = this.$root.$data.sharedStorage.getCurrentRun();
      if (this.graphBaseline && this.graphBaseline !== {} && !newBaselineData) {
        return;
      }

      if (newBaselineData) {
        this.graphBaseline = newBaselineData;
        return;
      }

      const scenario = this.currentRun.getScenario();

      this.graphBaseline =
        scenario && scenario.baselineId ? baselines[scenario.baselineId] : {};
    },
    calculateKpiBoxOutputs() {
      this.currentRun = this.$root.$data.sharedStorage.getCurrentRun();
      const savedOutput = this.currentRun.getSavedOutput();
      if (!savedOutput) {
        return;
      }
      this.kpiBoxOutputs = [];
      const zone = data.zoneCategories[this.chosenOutputZone].name;

      this.setBaseline();

      for (let output of data.outputs) {
        if (!output.display_in_results) {
          continue;
        }

        var values = savedOutput[output.name];
        if (!values) {
          continue;
        }

        if (output.per_zone_category) {
          values = values[zone];
        }
        const value = values.length > 0 ? values[values.length - 1] : null;

        // Formatting the baseline and value outputs

        // http://numeraljs.com/#format
        const formattedValue = numeral(value).format(output.format);

        let formattedBaselineValue;
        let formattedBaselineColor;
        let formattedBaselineArrowClass;

        //
        // For every other output KPI we want to compute the change
        // from the baseline value
        //
        var baselineValues = this.graphBaseline[output.name];
        if (baselineValues && baselineValues[zone]) {
          baselineValues = baselineValues[zone];
        }

        const baselineValue =
          baselineValues && baselineValues.length >= values.length
            ? baselineValues[values.length - 1]
            : 0;

        const smallChange =
          Math.abs(value - baselineValue) < output.no_change_limit;

        if (smallChange) {
          formattedBaselineColor = "amber";
          formattedBaselineArrowClass = "unchanged";
          formattedBaselineValue = `No change over ${this.graphBaselineName}`;
        } else {
          if (baselineValue > value) {
            if (output.format.indexOf("%") >= 0) {
              formattedBaselineValue = `${numeral(
                (baselineValue - value) * 100
              ).format(output.baselineComparisonFormat)} points lower than ${
                this.graphBaselineName
              }`;
            } else {
              formattedBaselineValue = `${numeral(baselineValue - value).format(
                output.baselineComparisonFormat
              )} lower than ${this.graphBaselineName}`;
            }

            formattedBaselineArrowClass = "lower";
            formattedBaselineColor = output.higher_than_base_is_better
              ? "red"
              : "green";
          } else {
            if (output.format.indexOf("%") >= 0) {
              formattedBaselineValue = `${numeral(
                (value - baselineValue) * 100
              ).format(output.baselineComparisonFormat)} points higher than ${
                this.graphBaselineName
              }`;
            } else {
              formattedBaselineValue = `${numeral(value - baselineValue).format(
                output.baselineComparisonFormat
              )} higher than ${this.graphBaselineName}`;
            }

            formattedBaselineArrowClass = "higher";
            formattedBaselineColor = output.higher_than_base_is_better
              ? "green"
              : "red";
          }
        }

        const obj = {
          name: output.name,
          format: output.format,
          label: output.label,
          perZoneCategory: output.per_zone_category,
          formattedValue: formattedValue,
          formattedBaselineValue: formattedBaselineValue,
          formattedBaselineColor: formattedBaselineColor,
          formattedBaselineArrowClass: formattedBaselineArrowClass
        };

        this.kpiBoxOutputs.push(obj);
      }
    },
    displayCurrentValues(zoneIndex) {
      this.chosenOutputZone = zoneIndex !== undefined ? zoneIndex : 0;

      const savedOutput = this.currentRun.getSavedOutput();
      if (!savedOutput) {
        return;
      }

      this.debug = savedOutput;
      this.calculateKpiBoxOutputs();
    },
    viewKPIDetails(output) {
      const savedOutput = this.currentRun.getSavedOutput();
      if (!savedOutput) {
        alert("There are no details to show");
        return;
      }
      this.detailsOutput = output;
      var _this = this;
      setTimeout(function() {
        _this.$root.$data.eventHub.$emit("show-kpi-modal");
      }, 200);
    },
    displayModal(modalName) {
      this.$root.$data.eventHub.$emit("show-" + modalName + "-modal");
    },
    loadRunToCompare(selectedRunSlug) {
      if (!selectedRunSlug || selectedRunSlug.indexOf("_") === -1) {
        return;
      }

      this.currentRun.setComparisionSlug(selectedRunSlug);

      const source = selectedRunSlug.split("_")[0];
      const index = selectedRunSlug.split("_")[1];

      if (source === "scenario") {
        this.graphBaselineName = data.scenarios[index].title;
        this.graphBaseline = baselines[data.scenarios[index].baselineId] || {};
      }

      if (source === "savedrun") {
        const savedRun = this.savedRuns[index];
        const run = new Run();
        run.addDataFromJson(savedRun);
        this.graphBaselineName = run.getName();
        this.graphBaseline = run.getSavedOutput() || {};
      }

      this.calculateKpiBoxOutputs();
      this.displayCurrentValues();
      this.calculateMapPopupValues();
    }
  }
};
</script>

<style lang="scss">
.mapComponentWidget {
  padding: 0;
}
#mapViewContainer {
  width: 500px;
  margin: 0 auto;
}
.focus-output .column .widget {
  height: 320px;
}
.kpi-container {
  position: relative;
  height: 195px;
  overflow: hidden;
  padding: 15px;
}
.kpi-container h4 {
  font-size: 16px;
  font-weight: 100;
  margin: 8px 0 4px 0;
}
.kpi-value {
  font-size: 50px;
  color: #009482;
  margin: 0;
}
.kpi-baseline {
  margin: 0 0 15px 0;
  font-size: 0.8em;
}
.kpi-footer {
  background-color: #e6e5e5;
  padding: 8px 6px;
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: 0px;
}
.kpi-footer a {
  color: #57626e;
  font-size: 0.8em;
  width: 100%;
  text-align: left;
}
.kpi-footer .charts-icon {
  width: 15px;
  height: 10px;
  margin: -2px 5px 0 5px;
}

.buttons {
  margin: 15px 0 10px 0;
}
.results-header-links,
.results-header-links:hover {
  color: #fff;
  font-size: 0.8em;
}
.help-button-container {
  padding-top: 20px;
}
.help-button b {
  font-weight: 400;
}
.help-button .badge {
  margin: -1px 3px 1px 0;
  background-color: #009482;
  font-size: 10px;
  width: 16px;
  height: 16px;
  padding: 3px 0 0 1px;
}
.nav-pills a {
  cursor: pointer;
}
</style>
